import { useEffect, useState } from "react";

import { AuthConfig } from "../../../setup/context/config/authConfig";
import styles from "./styles.module.css";

interface Props {
  nationalIdVerified?: boolean;
}

export const UserIdVerifiedIcon = (props: Props) => {
  const myInfo = AuthConfig.getMyInfo();
  const [nationalIdVerified, setNationalIdVerified] = useState<boolean>();
  useEffect(() => {
    setNationalIdVerified(
      props?.nationalIdVerified ?? myInfo?.nationalIdVerified
    );
  }, [myInfo?.nationalIdVerified, props]);
  return (
    <>
      {nationalIdVerified ? (
        <img
          className={styles.verifiedIcon}
          src={"/assets/images/svg/verifiedIcon.svg"}
        />
      ) : (
        <img
          className={styles.warningIcon}
          src={"/assets/images/svg/notVerifiedIcon.svg"}
        />
      )}
    </>
  );
};
